import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=6ebab4b2&scoped=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"
import style0 from "./FeedbackButton.vue?vue&type=style&index=0&id=6ebab4b2&prod&scoped=true&lang=css"
import style1 from "./FeedbackButton.vue?vue&type=style&index=1&id=6ebab4b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebab4b2",
  null
  
)

export default component.exports